function EventListWidgetCtrl($scope, WIDGET_DATA_TYPES) {
  $scope.type = $scope.type || 'TABLE';
  $scope.currentSection = 'BASIC';
  $scope.widgetBuilderConfig = {
    toolbar: [{
      visible: false,
      key: 'venueId',
      value: () => {
        return $scope.venue ? $scope.venue.id : null;
      }
    }, {
      name: 'Theme',
      key: 'theme',
      type: WIDGET_DATA_TYPES.SELECT,
      value: 'theme-light',
      selectValues: [{
        key: 'Light Theme',
        value: 'theme-light'
      }, {
        key: 'Dark Theme',
        value: 'theme-dark'
      }]
    }, {
      name: 'Event Count',
      key: 'eventCount',
      type: WIDGET_DATA_TYPES.NUMBER,
      value: 15
    }, {
      name: 'Button Background Color',
      key: 'buttonBgColor',
      type: WIDGET_DATA_TYPES.COLOR,
      value: '#017ecc'
    }, {
      name: 'Button Text Color',
      key: 'buttonTextColor',
      type: WIDGET_DATA_TYPES.COLOR,
      value: '#FFFFFF'
    }, {
      name: 'Button Text',
      key: 'buttonText',
      type: WIDGET_DATA_TYPES.STRING,
      value: 'Get Tickets'
    }, {
      visible: false,
      name: 'Display Type',
      key: 'eventDisplayType',
      type: WIDGET_DATA_TYPES.SELECT,
      value: 'type-3',
      selectValues: [{
        key: 'Type 1',
        value: 'type-1'
      }, {
        key: 'Type 2',
        value: 'type-2'
      }, {
        key: 'Type 3',
        value: 'type-3'
      }]
    }, {
      visible: false,
      name: 'Direction',
      key: 'eventDirection',
      type: WIDGET_DATA_TYPES.SELECT,
      value: 'vertical',
      selectValues: [{
        key: 'Horizontal',
        value: 'horizontal'
      }]
    }]
  };

  //TODO: need to pass the widget builder the 'type' field (TABLE vs. GUESTLIST)

  //code snippets
  $scope.reservationRequestSnippet1 = function () {
    return '<div id="event-list-widget"></div>';
  };

  $scope.reservationRequestSnippet2 = function () {
    if (!$scope.venue) return '';

    return `<script>
window.TablelistWidgets.onReady(function() {
var eventListWidget = new window.TablelistWidgets.widgets.EventListWidget('#event-list-widget'); //accepts either a String used as a CSS Selector, or a DOMNode

eventListWidget.init({
  venueId: '${$scope.venue.id}',
  eventCount: 15
});
});
</script>`;
  };
}

EventListWidgetCtrl.$inject = [
  '$scope',
  'WIDGET_DATA_TYPES'
];

export default EventListWidgetCtrl;



// WEBPACK FOOTER //
// ./src/directives/widgets/eventListWidget/controller.js